import { useEffect } from 'react';
import type { FieldPath, UseFormReturn } from 'react-hook-form';

import {
  roleApproverShortfall,
  type ApprovalChainFormContext,
  type ApprovalChainFormData,
  type ApprovalChainFormInput,
} from '../../model/schema';

/**
 * Validates each saved role step whose holders no longer meet its count, as after someone left
 * the role, as soon as the holders are known, so the chain opens showing why it cannot be saved.
 */
export function useShowSavedStepShortfalls(
  form: UseFormReturn<ApprovalChainFormInput, undefined, ApprovalChainFormData>,
  context: ApprovalChainFormContext,
): void {
  const { getValues, trigger } = form;
  const { roleHolders, savedSteps } = context;

  useEffect(() => {
    if (!roleHolders) return;
    const shortfallPaths = getValues('steps').flatMap((step, index) => {
      const isSaved = !!step.stepId && savedSteps.has(step.stepId);
      const shortfall = isSaved ? roleApproverShortfall(step, index, roleHolders) : null;
      return shortfall ? [shortfall.path.join('.') as FieldPath<ApprovalChainFormInput>] : [];
    });
    if (shortfallPaths.length > 0) void trigger(shortfallPaths);
  }, [getValues, trigger, roleHolders, savedSteps]);
}
